import PropTypes from 'prop-types';
import { Route, BrowserRouter as Router, Routes, Navigate } from "react-router-dom";

import { MainLayout } from "@gyandiksha/shared-ui/layouts";
import { ProtectedRoute } from "@gyandiksha/shared-ui/routes";
import { PageLoader, PageNotFound } from "@repo/design-system/components/ui";
import { defaultSidebarMenuConfig } from "../navigation/sidebarmenu.config";

// Sidebar menu config
import { getFirstNavigationPath } from '@gyandiksha/shared-ui/utils';
import { MODULE_IDS, useSidebarMenuConfig } from '@gyandiksha/shared-ui/hooks/useSidebarMenuConfig.js';

const AppRoutes = (props) => {

    const { sidebarMenuConfig, isFetching } = useSidebarMenuConfig({ moduleId: MODULE_IDS.usk_staff_attendance });
    const defaultPath = getFirstNavigationPath(sidebarMenuConfig)
        || getFirstNavigationPath(defaultSidebarMenuConfig);

    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    isFetching ? <PageLoader /> : <Navigate to={defaultPath} replace />
                } />
                <Route name="Layout" path="/"
                    element={
                        <ProtectedRoute sidebarMenuConfig={sidebarMenuConfig}>
                            {isFetching ? (
                                <PageLoader />
                            ) : (
                                <MainLayout componentRoutes={props.componentRoutes}
                                    sidebarMenuConfig={sidebarMenuConfig || defaultSidebarMenuConfig} />
                            )}
                        </ProtectedRoute>}>
                    {props.componentRoutes.map((route) => (
                        <Route
                            key={route.path}
                            path={route.path}
                            name=""
                            element={<route.component securityKey={route.securityKey} />}
                        />
                    ))}
                </Route>
                <Route path="*" element={<PageNotFound />} />
            </Routes>
        </Router>
    );
};

AppRoutes.propTypes = {
    componentRoutes: PropTypes.arrayOf(
        PropTypes.shape({
            path: PropTypes.string.isRequired,
            component: PropTypes.elementType.isRequired,
            securityKey: PropTypes.string,
        })
    ).isRequired,
};

export default AppRoutes;
